import React, {useEffect, useState} from 'react';
import {getUserFriendlyErrorMessage} from '@/utils/errorHandling.ts';
import {
  Button,
  EmptyState,
  ErrorHappened,
  HeadingSize,
  Label,
  LabelType,
  Loading,
  NoResultsFound,
  Search,
  SorterResult,
  Table,
  useKeyboardShortcut
} from '@fs/uikit-react';
import styles from './CategoriesPage.module.css';
import {ApiError} from '@/services/api';
import {
  refreshCategories,
  useInit
} from "@/pages/Operator/Category/hooks/useInit.ts";
import {
  filteredCategories,
  getRowActions,
  getTableColumns,
  handleCreateCategory,
  handleDeleteCategory,
  handleEditCategory
} from "@/pages/Operator/Category/components/CategoriesPage/table.tsx";
import {Category} from "@/shared/model/category.ts";

const CategoriesPage: React.FC = () => {
  const [searchValue, setSearchValue] = useState('');

  const [categories, setCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<ApiError | null>(null);
  const [sorters, setSorters] = useState<SorterResult[]>([]);

  useInit(setCategories, setLoading, setError);

  useEffect(() => {
    refreshCategories();
  }, []);

  useKeyboardShortcut('c', [], handleCreateCategory);

  const filtered = filteredCategories(categories, searchValue);

  const renderHeader = () => {
    return (
      <div className={styles.title}>
        <Label
          text={'Категорії'}
          type={LabelType.HEADING}
          headingSize={HeadingSize.L}
        />
        <div className={styles.buttonContainer}>
          <Button
            onClick={handleCreateCategory}
            title="Створити категорію"
          />
        </div>
      </div>
    );
  };

  const renderSearch = () => {
    return (
      <div className={styles.searchButtonContainer}>
        <div className={styles.searchContainer}>
          <Search
            placeholder="Пошук категорій"
            value={searchValue}
            onChange={setSearchValue}
          />
        </div>
      </div>
    );
  };

  const renderContent = () => {
    if (loading) {
      return <Loading text="Загружаємо категорії..." className={styles.loadingState} />;
    }

    if (error) {
      return <ErrorHappened text={getUserFriendlyErrorMessage(error as ApiError)} />;
    }

    if (filtered.length === 0) {
      if (searchValue) {
        return (
          <NoResultsFound
            text={`Немає результатів за запитом "${searchValue}"`}
          />
        );
      } else {
        return <EmptyState text="Немає доступних категорій" />;
      }
    }

    return (
      <Table
        data={filtered || []}
        columns={getTableColumns()}
        rowActions={getRowActions(handleDeleteCategory)}
        onClick={(record) => {
          handleEditCategory(record as Category);
        }}
        onSort={setSorters}
        initialSorters={sorters}
      />
    );
  };

  return (
    <div className={styles.container}>
      {renderHeader()}
      <div>
        {renderSearch()}
        {renderContent()}
      </div>
    </div>
  );
};

export default CategoriesPage;
